import { VktLogListWidget } from "../../widgets/VktLogListWidget";

const KoteachVirtualPage = () => {

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "90%",
      }}
    >
      <VktLogListWidget />
    </div>
  );
};

export default KoteachVirtualPage;
